import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=f85b31b2&scoped=true&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&id=f85b31b2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85b31b2",
  null
  
)

export default component.exports